import React from "react";
import PropTypes from "prop-types";
import { EmptyComponent } from "../../components/common/EmptyComponent.js";
import Loadable from "react-loadable";
import { UserContextSelectors } from "../../redux/selectors/index.js";
import { useSelector } from "react-redux";
import { PageContextUtils } from "../../utils/index.js";

const RegulationLogosSection = props => {
  const { showControlCenter } = props;
  const brandId = useSelector(UserContextSelectors.brandId);
  const { name } = PageContextUtils.getClientProviderData();
  try {
    const RegulationLogosSection = Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "[request]" */
          `../Brands/${brandId}/${name}/RegulationLogosSection.layout.js`
        ),
      loading: EmptyComponent
    });

    return (
      RegulationLogosSection && (
        <RegulationLogosSection showControlCenter={showControlCenter} />
      )
    );
  } catch {
    return null;
  }
};

RegulationLogosSection.propTypes = {
  showControlCenter: PropTypes.bool
};

export default React.memo(RegulationLogosSection);
